import r, { useRef as l } from "react";
import { CSSTransition as p } from "react-transition-group";
import t from "./swipeRightTransition.module.scss.js";
function d(m) {
  const {
    in: s,
    enter: i = 250,
    exit: e = 250,
    style: o,
    key: a,
    children: c
  } = m, n = l(null);
  return /* @__PURE__ */ r.createElement(
    p,
    {
      key: a,
      in: s,
      nodeRef: n,
      timeout: {
        enter: i,
        exit: e
      },
      style: {
        ...o,
        "--enter": `${i}ms`,
        "--exit": `${e}ms`
      },
      classNames: {
        enter: t.SwipeRightEnter,
        enterActive: t.SwipeRightEnterActive,
        exit: e === 0 ? t.ImmediateExit : t.SwipeRightExit,
        exitActive: e === 0 ? t.ImmediateExitActive : t.SwipeRightExitActive
      },
      unmountOnExit: !0
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        ref: n,
        "data-testid": "swipe-right-transition"
      },
      c
    )
  );
}
export {
  d as SwipeRightTransition
};
//# sourceMappingURL=SwipeRightTransition.js.map
